import { render, staticRenderFns } from "./form.vue?vue&type=template&id=4c356c7e"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c356c7e')) {
      api.createRecord('4c356c7e', component.options)
    } else {
      api.reload('4c356c7e', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=4c356c7e", function () {
      api.rerender('4c356c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reservation/form.vue"
export default component.exports